import { Item } from "../../../items/Item";
import Colors from "../../../Colors";
import { RDisplay } from "../../../../ui/RotDisplay";

const withColor = (c: string, s: string) => {
  return `%c{${c}}${s}%c{}`;
};

export const drawArmorText = (
  display: RDisplay,
  item: Item,
  x: number,
  y: number,
  maxWidth: number
) => {
  let o = 0;
  o += display.drawText(
    x,
    o + y,
    withColor(Colors.B_GREY_5, item.breed.name),
    maxWidth
  );
  if (item.breed.info) {
    o += display.drawText(x, o + y, item.breed.info, maxWidth);
  }
  o += 1;
  o += display.drawText(
    x,
    y + o,
    `%c{${Colors.B_GREY_3}}${item.breed.description}`,
    maxWidth
  );
  return o;
};

export const drawArmorDetails = (
  display: RDisplay,
  item: Item,
  x: number,
  y: number,
  maxWidth: number
) => {
  let o = 1;

  o += display.drawText(
    x,
    y + o,
    `Weight: ${item.breed.stats.weight}`,
    maxWidth
  );
  o += display.drawText(
    x,
    y + o,
    `Armor:  ${item.breed.stats.armor}`,
    maxWidth
  );
  o += display.drawText(
    x,
    y + o,
    `Poise:  ${item.breed.stats.poise}`,
    maxWidth
  );
  return o;
};
